const MAX_LENGTH = 2;

export const convertToTwoDigitsString = (digit: number | string): string => {
  return digit.toString().padStart(MAX_LENGTH, '0');
};
